define('lib/sanitizeHtml',['require','sanitize-html'],function(require) {
  var sanitizeHtml = require('sanitize-html');

  return function(html) {
    if (html) {
      return sanitizeHtml(html, {
        allowedTags: [ 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
        'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
        'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'span', 'u', 'del', 's', 'img' ],
        allowedAttributes: {
          a: ['href', 'name', 'target', 'rel'],
          img: ['src'],
          '*': ['class', 'style', 'data-*']
        }
      });
    } else {
      return '';
    }
  };

});

